let Sentry: typeof import("@sentry/react") | null = null;

async function initializeSentry() {
  if (Sentry) return Sentry;

  Sentry = await import("@sentry/react");
  Sentry.init({
    dsn: "https://9f17b5f261c146b5b184f250b7ac7513@o450450.ingest.sentry.io/6324159",
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_MH_VERSION,
    dist: import.meta.env.VITE_MH_VERSION,
    ignoreErrors: [
      "TypeError: Failed to fetch",
      "TypeError: NetworkError when attempting to fetch resource.",
      "TypeError: Cancelled",
      "TypeError: Cannot redefine property: googletag",
      "Load failed",
      /Failed to fetch dynamically imported module/i,
      /signal is aborted without reason/i,
      "Can't find variable: Bridge",
      "Bridge is not defined",
      "Method not found",
      /chrome-extension/i,
      "Object Not Found Matching",
      "Importing a module script failed",
      "Can't find variable: shareInfo",
      "Can't find variable:",
      /Maximum call stack size exceeded/i,
    ],
    integrations: [
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ["moneyhash-sentry-application-key"],
        behaviour: "drop-error-if-contains-third-party-frames",
      }),
    ],
  });
  Sentry.setTag("mh-version", import.meta.env.VITE_MH_VERSION);
}

export async function logToSentry(
  obj: Error | Record<string, unknown>,
  type: "error" | "event" = "error",
  eventMessage = "Logger"
) {
  try {
    const loggerFunc = type === "error" ? console.error : console.log; // Log error or event to console for clarification
    loggerFunc(obj);

    // Disable sentry on local development
    if (
      ["staging", "production", "preprod"].includes(
        import.meta.env.MODE as string
      ) &&
      process.env.NODE_ENV === "production"
    ) {
      await initializeSentry();
      const objId =
        type === "error"
          ? Sentry.captureException(obj)
          : Sentry.captureEvent({
              message: eventMessage,
              level: "log",
              extra: obj as Record<string, unknown>,
            });

      return objId;
    }

    return "DISABLED SENTRY | Check console for more details";
  } catch (e) {
    // all fails, reset window.onerror to prevent infinite loop on window.onerror
    console.error("Logging to Sentry failed", e);
    window.onerror = null;

    return "UNKNOWN";
  }
}
